import request, { IWorkspaceResponse } from '/@/api/http/request'
import { FlightWeatherData } from '/@/types/flight-weather'

const HTTP_PREFIX = '/manage/api/v1/weather'

export async function getFlightWeather (
  longitude: number,
  latitude: number
): Promise<IWorkspaceResponse<FlightWeatherData>> {
  const result = await request.get(`${HTTP_PREFIX}/flight`, {
    params: { longitude, latitude },
    skipErrorMessage: true,
  } as any)
  return result.data
}
